export const createCompletionsFromSchema = (schema) => {
  const completions = [];

  if (!schema || typeof schema !== "object") {
    return completions;
  }

  const extractProperties = (obj, path = "") => {
    for (const key in obj) {
      if (!Object.prototype.hasOwnProperty.call(obj, key)) continue;

      const fullPath = path ? `${path}.${key}` : key;
      const value = obj[key];
      const valueType = Array.isArray(value) ? "array" : typeof value;

      completions.push({
        label: key,
        type: "property",
        detail: valueType,
        info: fullPath,
        apply: key
      });

      if (typeof value === "object" && value !== null && !Array.isArray(value)) {
        extractProperties(value, fullPath);
      }
    }
  };

  extractProperties(schema);
  return completions;
};
